import Title from 'components/Title';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'styled-icons/fa-solid';
import TableCommercialProduct from './components/TableCommercialProduct';
import { Container } from './styles';

const Users: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Title>Produtos Comerciais</Title>
      <Row>
        <Col xs={12} sm={6}>
          <Button
            variant="outline-primary"
            title="Produtos Comerciais"
            onClick={() => navigate('addEditCommercialProduct')}
          >
            <Plus size="20" />
          </Button>
        </Col>
      </Row>
      <br />
      <TableCommercialProduct />
    </Container>
  );
};

export default Users;
